function cov_10j2bklfst() {
  var path = "/app/src/components/logo/components/logo-en-green-on-black/index.ts";
  var hash = "16f60b5b8e93f445d322c422c5d04a6c8a9bc3d4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-green-on-black/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "16f60b5b8e93f445d322c422c5d04a6c8a9bc3d4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_10j2bklfst = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_10j2bklfst();
export { LogoEnGreenOnBlack } from './logo-en-green-on-black';